export const OVERLAY_ACTION_TYPES = {
  TOGGLE_OVERLAY: 'TOGGLE_OVERLAY',
  HIDE_ALL_OVERLAYS: 'HIDE_ALL_OVERLAYS',
};
